const MceIcon = ({
  icon,
  inverse,
  className,
  varColor = "--color-brand-primary-medium",
  style,
  ...sizes
}) => {
  const sizeOrder = ["xxs", "xs", "sm", "md", "lg", "xl", "xxl"];

  const computedSize = sizeOrder.find((size) => sizes[size]) || "md";

  return (
    <span
      style={{ color: `var(${varColor})`, ...style }}
      className={`mdn-Icon-${icon} mdn-Icon--${computedSize} ${
        inverse ? "inverseIcon" : ""
      } ${className ?? ""}`}
      aria-label={icon}
    ></span>
  );
};

export default MceIcon;
